import { render, staticRenderFns } from "./AuthDownload.vue?vue&type=template&id=7984f265&scoped=true&"
import script from "./AuthDownload.vue?vue&type=script&lang=js&"
export * from "./AuthDownload.vue?vue&type=script&lang=js&"
import style0 from "./AuthDownload.vue?vue&type=style&index=0&id=7984f265&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7984f265",
  null
  
)

export default component.exports